import angular from 'angular';

import BlndTable from 'app/common/table';

import changeModalTpl from './templates/edit.modal.html';


class EditModalCtrl {

    constructor ($uibModalInstance, R, company, object) {
        "ngInject";
        this.$modal = $uibModalInstance;
        this.object = object;
        this.company = company;
        this.data = R.copy(this.object);
    }

    get title () {
        return `Edit`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;

        self.loading = true;
        self.data.put().then(
            (response) => {
                angular.extend(self.object, response);
                self.$modal.close();
            },
            (response) => {
                self.errors = response.data;
            }
        ).finally(() => self.loading = false);
    }
}


class AddModalCtrl {

    constructor ($uibModalInstance, $stateParams, ChemicalProgramStore, company, isAdding) {
        "ngInject";
        this.$modal = $uibModalInstance;
        this.store = ChemicalProgramStore;
        this.company = company;
        this.isAdding = isAdding;
        this.data = {
            companies: [{id: $stateParams.companyId}]
        };
    }

    get title () {
        return `Add new chemical program`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        self.loading = true;
        self.store.create(self.data).then(
            (response) => {
                self.$modal.close(response.id);
            },
            (response) => {
                self.errors = response.data;
            }
        ).finally(() => this.loading = false);
    }
}

export class ListCtrl {

    constructor (NgTableParams, $company, $state, $stateParams, $growl, Modal, ChemicalProgramStore) {
        "ngInject";

        this.Modal = Modal;
        this.$state = $state;
        this.$growl = $growl;
        this.store = ChemicalProgramStore;
        this.company = $company;
        this.params = {
            is_active: 'yes',
            company: this.company.id,
        };

        this.selectedObject = $stateParams.objectId;

        this.table = new BlndTable(NgTableParams, this.store, {
            defaultParams: {
                page_size: 20,
            }
        });
    }

    openModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: changeModalTpl,
            controller: AddModalCtrl,
            resolve: {
                isAdding: true,
                company: self.company,
            }
        });

        $modal.result.then((objectId) => {
            self.refresh();
            self.table.store.$promise.then(() => {
                self.selectRow(objectId);
            });
        });
    }

    selectRow (objectId) {
        this.selectedObject = objectId;
        this.$state.go('r.in.top.admin.company.chemicals.list.program', {objectId: objectId});
    }

    refresh () {
        return this.table.refresh(this.params);
    }

}


export class DetailCtrl {

    constructor ($rootScope, Modal, $company, $growl, $state, $object) {
        "ngInject"

        this.Modal = Modal;
        this.object = $object;
        this.$state = $state;
        this.$growl = $growl;
        this.company = $company;

        $rootScope.object = this.object;
    }

    openModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: changeModalTpl,
            controller: EditModalCtrl,
            resolve: {
                object: () => self.object,
                company: () => self.company,
            },
        });

        $modal.result.then(() => {
            self.$growl.updated();
            self.$state.go(self.$state.current, {}, {reload: true});
        });
    }



}



// WEBPACK FOOTER //
// ./src/app/admin/chemical_programs/ctrls.js